import { Box, Dialog, Text } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { ModalSearchHeader } from '../ModalSearchHeader';
import { ArticleModalRouter } from './ArticleModalRouter';
import { useModalNavigation } from '../ModalNavigationContext';

type Props = {
  handleClose: () => void;
};

export const ArticleModalContent = ({ handleClose }: Props): ReactElement => {
  const modalNav = useModalNavigation();

  const shouldShowBackButton = modalNav?.screen.name !== 'categories';

  return (
    <>
      <ModalSearchHeader
        handleClose={handleClose}
        title="Lernkarte einfügen"
        shouldShowBackButton={shouldShowBackButton}
      />
      <Dialog.Content
        p={{ base: '15px 20px 40px', md: '15px 20px 25px' }}
        scrollbar="hidden"
        maxHeight="100%"
      >
        <ArticleModalRouter />
      </Dialog.Content>
      <Box position="absolute" bottom="0" left="0" right="0" background="blue" p="l">
        <Text>lalelu</Text>
      </Box>
    </>
  );
};
